"use client"
import React, { useState, useEffect } from "react";
import Asset from "@/components/shared/Asset";
import MapLink from "@/components/shared/MapLink";
import moment from "moment";
import { useConfig } from "@/lib/providers/ConfigProvider";

import "@/components/maps/embed/EmbeddedContent.css";
import MetadataThumbnail from "@/components/shared/MetadataThumbnail";

const EmbeddedPostContent = ({ post, url, coordinates, autoPlay }) => {
  const [metadata, setMetadata] = useState(null);
  const { webUrl } = useConfig();
  useEffect(() => {
    if (post && post.mapPoint && post.mapPoint.metadata) {
      setMetadata(JSON.parse(post.mapPoint.metadata));
    }
  }, [post]);

  return (
    <>
      {post.mapPoint.source === "URALITY" &&
        post.mapPoint.assets &&
        post.mapPoint.assets.length > 0 && (
          <Asset assets={post.mapPoint.assets} autoPlay={autoPlay} />
        )}
      {post.mapPoint.source === "URALITY" && (
        <>
          {post.mapPoint.title && (
            <div className="embedded-content-section">
              <h3>{post.mapPoint.title}</h3>
            </div>
          )}
          <div className="embedded-content-section">
            <p>{post.mapPoint.text}</p>
          </div>
        </>
      )}
      {post.mapPoint.location && (
        <div className="embedded-content-section">
          <MapLink location={post.mapPoint.location} />
        </div>
      )}
      <h4>
        <div className="embedded-content-section span">
          <span className="material-icons">watch_later</span>
          <span style={{ paddingLeft: "0.25rem" }}>
            Posted {moment(post.createdDate).fromNow()}
          </span>
        </div>
      </h4>
      {post.type === "GALLERY" && (
        <div className="default-card-wrapper-content-cta">
          <a
            className="btn btn-secondary"
            href={`${webUrl}${post.owner.resourceName}/pins/${post.id}`}
            target={external ? "_blank" : "_self"}
            rel="noopener noreferrer"
          >
            View Gallery
          </a>
        </div>
      )}
      {post.type === "EXTERNAL_LINK" && post.mapPoint.url && (
        <MetadataThumbnail
          ownerId={post.owner.id}
          contentId={post.id}
          type="POST"
          image={true}
          metadata={metadata}
          url={post.mapPoint.url}
          clickable={true}
          className="map-point-external-link"
        />
      )}
    </>
  );
};
export default EmbeddedPostContent;
